import React from 'react';
import './stylesLoader.css';

export const TruckLoader = ({ message = "Cargando datos...", progreso }) => {
  const showProgress = progreso !== null && progreso !== undefined;

  return (
    <div className="tl-overlay">
      <div className="tl-card">
        {/* Camión amarillo animado */}
        <div className="tl-truck-wrapper">
          <div className="truck">
            <div className="truck-container"></div>
            <div className="glases"></div>
            <div className="bonet"></div>
            <div className="base"></div>
            <div className="base-aux"></div>
            <div className="wheel-back"></div>
            <div className="wheel-front"></div>
            <div className="smoke"></div>
          </div>
        </div>

        {showProgress ? (
          <div className="tl-progress-section">
            <p className="tl-progress-count">{progreso.actual}/{progreso.total}</p>
            <div className="tl-progress-row">
              <div className="tl-progress-bar-container">
                <div className="tl-progress-bar-fill" style={{ width: progreso.porcentaje + '%' }} />
              </div>
              <span className="tl-progress-percent">{Math.round(progreso.porcentaje)}%</span>
            </div>
            <p className="tl-message">Preparando archivo Excel...</p>
          </div>
        ) : (
          <div className="tl-progress-section">
            <div className="tl-progress-bar-container">
              <div className="tl-progress-bar-animated" />
            </div>
            <p className="tl-message">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
};
